import * as actionTypes from "./actionTypes";
import { getTypesOfScoreAPI, deleteTypesOfScoreAPI, createTypesOfScoreAPI, modifyTypesOfScoreAPI } from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    case "IN_USE_EVAL":
      errorString = getLocalizedString("cannotDeleteNoteTypeBecauseInUseInPerformanceEvaluationProcesses");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getTypesOfScoreAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_TYPES_OF_SCORE });
  try {
    let response = await getTypesOfScoreAPI();

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_TYPES_OF_SCORE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_TYPES_OF_SCORE_FULFILLED,
      payload: {
        data
      }
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_TYPES_OF_SCORE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const deleteTypesOfScoreAction = (code, typeOfScoreName) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_TYPES_OF_SCORE });
  try {
    let response = await deleteTypesOfScoreAPI({ code });


    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.DELETE_TYPES_OF_SCORE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DELETE_TYPES_OF_SCORE_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("typeOfScoreDeletedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_TYPES_OF_SCORE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const createTypesOfScoreAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_TYPES_OF_SCORE });
  try {
    let response = await createTypesOfScoreAPI(dataToSend);

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.CREATE_TYPES_OF_SCORE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.CREATE_TYPES_OF_SCORE_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("typeOfScoreCreatedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_TYPES_OF_SCORE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const modifyTypesOfScoreAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY_TYPES_OF_SCORE });
  try {
    let response = await modifyTypesOfScoreAPI(dataToSend);

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.MODIFY_TYPES_OF_SCORE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.MODIFY_TYPES_OF_SCORE_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("typeOfScoreModifiedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.MODIFY_TYPES_OF_SCORE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};